import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { MarkdownLink } from 'site-modules/canvas/components/chat-messages/ai-message/markdown/markdown-link/markdown-link';
import { AnimationSchedule } from 'site-modules/canvas/components/animation-schedule/animation-schedule';
import { WordByWordRenderer } from 'site-modules/canvas/components/chat-messages/ai-message/markdown/word-by-word-renderer/word-by-word-renderer';

import './markdown-link-renderer.scss';

export function MarkdownLinkRenderer({
  children = undefined,
  isAnimationDisabled = false,
  onLinkClick = noop,
  unitId = 'link',
  blocksFollowing = false,
  ...restProps
}) {
  if (children === 'edmunds.com') {
    return (
      <AnimationSchedule.MarkdownScheduledNode
        {...restProps}
        as={MarkdownLink}
        unitId={unitId}
        isAnimationDisabled={isAnimationDisabled}
        reportAsRevealLeaf
        blocksFollowing={blocksFollowing}
        onClick={onLinkClick}
        className="link-emoji-wrapper text-cool-gray-50 bg-cool-gray-80 d-inline-flex justify-content-center align-items-center text-decoration-none"
        aria-label={children}
      >
        <i className="icon-link size-12" aria-hidden />
      </AnimationSchedule.MarkdownScheduledNode>
    );
  }

  return (
    <MarkdownLink {...restProps} onClick={onLinkClick}>
      <WordByWordRenderer
        tag={Fragment}
        unitId={unitId}
        isAnimationDisabled={isAnimationDisabled}
        blocksFollowing={blocksFollowing}
      >
        {children}
      </WordByWordRenderer>
    </MarkdownLink>
  );
}

MarkdownLinkRenderer.propTypes = {
  children: PropTypes.node,
  isAnimationDisabled: PropTypes.bool,
  onLinkClick: PropTypes.func,
  unitId: PropTypes.string,
  blocksFollowing: PropTypes.bool,
};
